import BaseComponent from "core/BaseComponent";
import BaseBlock from "core/Block";

export const Block = BaseBlock;

export const Component = BaseComponent;
